// extracted by mini-css-extract-plugin
export default {"dialogContent":"efBvJnm37g8HgH0LKe3L"};